/**
 * Better Auth 客户端配置
 * https://www.better-auth.com/docs/concepts/client
 *
 * 不挂载 adminClient：租户管理员不得暴露 Better Auth 全局 admin API surface。
 * 用户管理统一走 tRPC tenantUser 路由。
 */

import { createAuthClient } from "better-auth/react";
import { usernameClient } from "better-auth/client/plugins";

/**
 * Auth 客户端实例
 */
export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
  plugins: [
    usernameClient(),
  ],
});

// 导出常用方法
export const {
  signIn,
  signOut,
  useSession,
} = authClient;
